import React from 'react';
import { Col } from 'antd';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import PropTypes from "prop-types";
import Address from "./Address";

class DonorDetails extends React.Component {
    constructor(props) {
        super(props);
        this.renderInputComponent = this.renderInputComponent.bind(this);
    }

    renderInputComponent = () => {
        let htmlData = [];
        if(this.props.type === "Individual"){
            let id = 0;
             htmlData.push(
                    <Col>
                    <Address data-test="IndividualAddress" assetHeld={this.props.assetHeld} accountId={this.props.accountId} contributionType={this.props.contributionType} donorId={id} type={this.props.type} count={this.props.count} />
                    </Col>
                )

        }else{

        htmlData = this.props.donorDetails.map((donor, index) => {
            if(index === 0){
            return(
                <Col>
                <Address data-test="OtherAddress0" assetHeld={this.props.assetHeld} accountId={this.props.accountId} contributionType={this.props.contributionType} donorId={index} type={this.props.type} count={this.props.count} />
                </Col>
            )
            }{
                return(
                    <Col >
                    <Address data-test="OtherAddress" assetHeld={this.props.assetHeld} accountId={this.props.accountId} contributionType={this.props.contributionType} donorId={index} type={this.props.type} count={this.props.count} />
                    </Col>
                )
            }
        });
    }
    return htmlData;
    }

    render() {
        return (
            <>
                {this.renderInputComponent()}
            </>
        )
    }
}

DonorDetails.propTypes = {
    donorDetails: PropTypes.array
}

const mapStateToProps = (state, ownProps) => ({
    donorDetails: state.getIn(["makeAContribution", "contributionTypes", `${ownProps.assetHeld}`, `${ownProps.contributionType}`,`${ownProps.accountId}`,"Donors"])
});

export default withRouter(connect(mapStateToProps, null)(DonorDetails));

